package com.starparty.app.astro0

import com.starparty.app.vector_maths.Matrix4d
import kotlin.math.PI

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class Grid {
    protected var itsNumOfLonLines = 12
    protected var itsNumOfLatLines = 11

    var lonLines: Array<Circle> = arrayOf()
        protected set
    var latLines: Array<Circle> = arrayOf()
        protected set


    constructor(numOfLonLines: Int, numOfLatLines: Int) {
        itsNumOfLonLines = numOfLonLines
        itsNumOfLatLines = numOfLatLines

        createGridLines()
    }

    fun project(m: Matrix4d) {
        // project longitude lines.
        for (lon in lonLines.indices) {
            lonLines[lon].project(m)
        }

        // project latitude lines.
        for (lat in latLines.indices) {
            latLines[lat].project(m)
        }
    }

    fun createGridLines() {

        val lonSpacing = PI / itsNumOfLonLines
        val latSpacing = PI / (itsNumOfLatLines + 1)

        val tempLonLines: MutableList<Circle> = mutableListOf()
        val tempLatLines: MutableList<Circle> = mutableListOf()

        // create longitude lines.
        for (lon in 0 until itsNumOfLonLines) {
            val lonAngle = lon * lonSpacing
            tempLonLines.add(Circle(false, lonAngle))
        }

        // create latitude lines.
        for (lat in 0 until itsNumOfLatLines) {
            val latAngle = (lat + 1) * latSpacing - (PI/2.0)
            tempLatLines.add(Circle(true, latAngle))
        }

        latLines = tempLatLines.toTypedArray()
        lonLines = tempLonLines.toTypedArray()
    }
}